import React ,{useState, useEffect} from 'react';
export default function Firm(){
    const [content,setContent] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    // sample for filtering content,. eg. partners or associates etc
    const mUrl = "https://cms.lizakhan.com/items/content?filter[textKey][_eq]=theFirm";

    useEffect(()=>{
	fetch(mUrl).then(res => res.json()).then(result => {
	    setLoading(true);
	    console.log(result.data);
	    setContent(result.data);
	}).catch(error =>{
	    setLoading(true);
	    setError(error);
	})
    }, []);


    if(error){
	return <div> Error: {error}</div>;
    } else if(!loading){
	return <div>Loading ...</div>;
    } else{
	return(<main>		   
		   


		   {content &&  content.map(item =>
		       <div className="container px-4 py-5">
			   <h2 className="pb-2 border-bottom">{item.title}</h2>
			   <div class="container my-5">
			       <div class="row p-4 pb-0 pe-lg-0 pt-lg-5 align-items-center rounded-3 border shadow-lg">
				   <div class="col">
				       <p class="quote logoColor">{item.quote}</p>
				       <p>{item.lead}</p>
				       <div dangerouslySetInnerHTML={{ __html: item.body }} />
				   </div>
				   <div class="row">
				       <div class="col-lg-12 bg-logoColor px-3 py-3 my-3" dangerouslySetInnerHTML={{ __html: item.main }} />
				   </div>
			       </div>
			   </div>
			   
		       </div>
		   )}
		   
	       </main>)
    }
}
